import { patientSchema } from '@billing/validation/patient';
import { Healthcard } from './healthcard';
import { Organization } from './organization';

export interface PatientName {
  id: string;
  firstName: string;
  lastName: string;
  healthcards?: Healthcard[];
}

export interface Patient extends PatientName {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  address: string;
  city: string;
  country: string;
  postalCode: string;
  sex: string;
  maritalStatus: string;
  province: string;
  healthcardID?: string;
  email: string | null;
  phone: string | null;
  searchVector: string | null;
  healthcards: Healthcard[];
  organizationID: string;
  organization: Organization | null;
}

/**
 * Search results returned by the `useSearchPatients` hook.
 * Extends the `Patient` interface and includes additional fields.
 * @interface SearchPatientResult
 * @extends Patient
 * @property {string} number - Patient's PHIN.
 * @property {string} registration - The patient's registration number.
 */

export interface SearchPatientResult extends Patient {
  number: string;
  registration: string;
}

export type FormPatient = Omit<Patient, 'id'>;

export const isPatient = (obj: any): obj is Patient => {
  return patientSchema.safeParse(obj).success;
};

export const isSearchPatientResult = (obj: any): obj is SearchPatientResult => {
  return patientSchema.safeParse(obj).success;
};
